// Observable class extensions
import 'rxjs/add/observable/of'
import 'rxjs/add/observable/fromPromise'
import 'rxjs/add/observable/combineLatest'
import 'rxjs/add/observable/throw'

// Observable operators
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/withLatestFrom'
import 'rxjs/add/operator/take'
import 'rxjs/add/operator/finally'
import 'rxjs/add/operator/takeWhile'
import 'rxjs/add/operator/takeUntil'
import 'rxjs/add/operator/skip'



// WEBPACK FOOTER //
// ./src/app/models/rxjs-operators.ts